import React, { Component, useCallback } from 'react';
import styled from 'styled-components';
import Logo from '../assets/logo-white.png';
import { useDispatch } from 'react-redux';
import { logout } from '../../services/user/actions';

type LogoutWrapperProps = {
    elemType?: 'div' | 'span' | 'button' | 'a';
};

// A logout button/span/div you can take with you anywhere!
// Or not use and just replace!
const LogoutComponent = ({ elemType = 'span' }: LogoutWrapperProps) => {
    const dispatch = useDispatch();

    const dispatchLogout = useCallback(() => dispatch(logout()), [dispatch]);
    return React.createElement(
        elemType,
        {
            onClick: dispatchLogout,
        },
        'Logout'
    );
};


const StyledLogoutWrapper = styled.div`
  cursor: pointer;
`;

// A logout wrapper you can put over whatever and it will log you out
const LogoutWrapper: React.FC = props => {
    const dispatch = useDispatch();

    const dispatchLogout = useCallback(() => dispatch(logout()), [dispatch]);

    return <StyledLogoutWrapper onClick={dispatchLogout}>
        {props.children}
    </StyledLogoutWrapper>
};

export { LogoutComponent as Logout, LogoutWrapper };
